import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Vidyaman from "../../components/public/vidyaman";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"कार्यकारी मंडळ"} content={<Vidyaman />} />
      <Footer />
    </>
  );
};
